import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { ProductDiscountedPriceDto } from '@api/models';
import { IconComponent } from '../icon/icon.component';

/** What a product costs per tier, and how much has to be in the cart for each of them. */
@Component({
  selector: 'product-discounts',
  templateUrl: './product-discounts.component.html',
  styleUrls: ['./product-discounts.component.scss'],
  imports: [IconComponent, TranslatePipe],
  host: {
    '[class.compact]': 'isCompact()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductDiscountsComponent {
  readonly discountedPrices = input.required<ProductDiscountedPriceDto[]>();
  /** The tier the product sells at, from `resolveActivePriceIndex`. */
  readonly activeIndex = input<number | undefined>(undefined);
  readonly isAggregator = input(false);
  /** Smaller type, for the places that fit a whole product into a row. */
  readonly isCompact = input(false);
}
